/**
 * This hook builds on useAsyncRetry by automatically trying to fire the
 * callback again if it errors. If the retries number
 *
 */
import { useState, useEffect } from "react";
import useAsyncRetry from "react-use/lib/useAsyncRetry";

export default function useAsyncRetryMax<T = any>(
  fn: () => Promise<T>,
  maxRetries: number = 3,
  args?: any[]
): {
  retry: () => void;
  retries: number;
  loading: boolean;
  error?: Error | undefined;
  value?: T | undefined;
} {
  const attempt = useAsyncRetry(fn, args);
  const [retries, setRetries] = useState(0);

  // Retry a new attempt if it errored
  useEffect(() => {
    if (attempt.error) {
      if (retries < maxRetries) {
        attempt.retry();
        setRetries(retries + 1);
      }
    }
  }, [attempt.error, retries]);

  return { ...attempt, retries };
}
